import React, { useEffect, useState } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Ticket } from "@phosphor-icons/react";

export default function AdminDiscounts() {
  const [items, setItems] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ code: "", percent_off: 10, amount_off: 0, max_uses: "", valid_until: "" });

  const load = async () => { const { data } = await api.get("/discounts"); setItems(data.items); };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const create = async () => {
    if (!form.code) { toast.error("Code required"); return; }
    try {
      await api.post("/discounts", {
        ...form,
        max_uses: form.max_uses ? Number(form.max_uses) : null,
        valid_until: form.valid_until || null,
      });
      toast.success("Code created");
      setShowNew(false); setForm({ code: "", percent_off: 10, amount_off: 0, max_uses: "", valid_until: "" });
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  const toggle = async (id, active) => { await api.patch(`/discounts/${id}`, { is_active: active }); load(); };

  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-5xl mx-auto px-6 lg:px-8 py-10">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Promotions</div>
            <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl">Discount codes.</h1>
          </div>
          <Button data-testid="disc-new-btn" onClick={() => setShowNew(!showNew)} className="rounded-sm"><Plus size={14} className="mr-2" /> New code</Button>
        </div>

        {showNew && (
          <div className="border border-border bg-white p-6 mb-6 space-y-3">
            <div className="grid md:grid-cols-2 gap-3">
              <div><Label>Code</Label><Input data-testid="disc-code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} className="mt-1" placeholder="WELCOME10" /></div>
              <div><Label>Percent off</Label><Input type="number" value={form.percent_off} onChange={(e) => setForm({ ...form, percent_off: e.target.value })} className="mt-1" /></div>
              <div><Label>Amount off (currency units)</Label><Input type="number" value={form.amount_off} onChange={(e) => setForm({ ...form, amount_off: e.target.value })} className="mt-1" /></div>
              <div><Label>Max uses</Label><Input type="number" value={form.max_uses} onChange={(e) => setForm({ ...form, max_uses: e.target.value })} className="mt-1" placeholder="unlimited" /></div>
              <div className="md:col-span-2"><Label>Valid until</Label><Input type="date" value={form.valid_until} onChange={(e) => setForm({ ...form, valid_until: e.target.value })} className="mt-1" /></div>
            </div>
            <div className="flex gap-2">
              <Button data-testid="disc-save" onClick={create} className="rounded-sm">Save code</Button>
              <Button variant="ghost" onClick={() => setShowNew(false)} className="rounded-sm">Cancel</Button>
            </div>
          </div>
        )}

        <div className="border border-border bg-white">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left">
              <tr className="text-xs uppercase tracking-widest-2 text-muted-foreground">
                <th className="p-3">Code</th>
                <th className="p-3">Discount</th>
                <th className="p-3">Uses</th>
                <th className="p-3">Valid until</th>
                <th className="p-3">Active</th>
              </tr>
            </thead>
            <tbody>
              {items.map((d) => (
                <tr key={d.code_id} className="border-t border-border">
                  <td className="p-3 font-mono">{d.code}</td>
                  <td className="p-3">
                    {d.percent_off > 0 && <span>{d.percent_off}%</span>}
                    {d.amount_off > 0 && <span> +{d.amount_off}</span>}
                  </td>
                  <td className="p-3">{d.times_used}{d.max_uses ? ` / ${d.max_uses}` : ""}</td>
                  <td className="p-3 text-xs text-muted-foreground">{d.valid_until ? new Date(d.valid_until).toLocaleDateString() : "—"}</td>
                  <td className="p-3"><Switch checked={d.is_active} onCheckedChange={(v) => toggle(d.code_id, v)} data-testid={`disc-toggle-${d.code_id}`} /></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-muted-foreground text-sm"><Ticket size={20} weight="duotone" className="mx-auto mb-2 text-muted-foreground" />No discount codes yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}
